import axios from 'axios';
import { all, put, takeEvery, takeLatest } from 'redux-saga/effects';

import { USER_MANUAL } from 'app/api-routes';
import {
  askRequest,
  askSuccess,
  askFailure,
  feedbackRequest,
  feedbackSuccess,
  feedbackFailure,
} from './actions';

const SERVER_TO_I18N_ERROR = {
  aiDisabledForAccount: 'ai_disabled_for_account',
  aiQuotaExceeded: 'ai_quota_exceeded',
  aiRequestFailed: 'ai_request_failed',
  permissionDenied: 'ask_manual_no_permission',
};

const errorCodeFrom = (err) => {
  const data = err?.response?.data;
  const serverCode = data?.errorCode || data?.errors?.[0]?.code || null;
  return SERVER_TO_I18N_ERROR[serverCode] || (serverCode ? 'ai_request_failed' : null);
};

function* askSaga({ payload }) {
  const { category, question } = payload;
  try {
    const { payload: data, warnings } = yield axios.post(
      `${USER_MANUAL}/ask`,
      { payload: { category, question } }
    );
    yield put(askSuccess(data, { warnings }));
  } catch (err) {
    yield put(askFailure({ error: errorCodeFrom(err) }));
  }
}

function* feedbackSaga({ payload }) {
  const { logID, helpful } = payload;
  if (logID == null) return;
  try {
    yield axios.post(`${USER_MANUAL}/feedback/${logID}`, null, {
      params: { helpful },
    });
    yield put(feedbackSuccess({ logID, helpful }));
  } catch (err) {
    yield put(feedbackFailure({ logID, error: errorCodeFrom(err) }));
  }
}

export default function* () {
  yield all([
    takeLatest(askRequest, askSaga),
    takeEvery(feedbackRequest, feedbackSaga),
  ]);
}
